import { useRouter } from 'next/router'

import Link from '@/update-monitor/Link'
import { cn } from '@/utils/tw-helpers'

import { menus } from './constant'

export const EnterpriseNav = (): JSX.Element => {
  const router = useRouter()

  return (
    <nav>
      <ul>
        {menus.map((item, index) => (
          <li key={index}>
            <Link
              href={item.href}
              className={cn(
                'flex h-[64px] items-center px-6 text-[15px] font-bold',
                router.pathname.includes(item.href)
                  ? 'bg-white text-primary-100'
                  : 'bg-transparent text-secondary-text'
              )}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
